import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {},
  isLoaded: false,
};

const treatmentDemandQuestionOptionsSlice = createSlice({
  name: "treatmentDemand",
  initialState,
  reducers: {
    setTreatmentDemandsQuestionOptions: (state, { payload }) => {
      state.list = payload;
      console.log('[quesitonOptionsSlice] Payload:', payload);
    },
    addTreatmentDemandsQuestionOptionsToList: (state, { payload }) => {
      state.list = { ...state.list, payload };
    },
    updateTreatmentDemandsQuestionOptions: (state, { payload }) => {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
    removeTreatmentDemandsQuestionOptionsFromList: (state, { payload }) => {
      state.list = state.list.filter((item) => item.id !== payload);
    },
    setSelectedTreatmentDemandsQuestionOptions: (state, { payload }) => {
      state.selected = payload;
    },
    clearSelectedQuestions: (state) => {
      state.selected = {
        optionText: "",
        questionId: "",
      };
    },
  },
});
export const {
  setSelectedTreatmentDemandsQuestionOptions,
  setTreatmentDemandsQuestionOptions,
  addTreatmentDemandsQuestionOptionsToList,
  updateTreatmentDemandsQuestionOptions,
  removeTreatmentDemandsQuestionOptionsFromList,
  clearSelectedQuestions,
} = treatmentDemandQuestionOptionsSlice.actions;
export default treatmentDemandQuestionOptionsSlice.reducer;
